module.exports = __webpack_public_path__ + "img/12.20744b72.webp";